export const candidateActionTypes = {
  editCandidate: '[CandidateListItem detail] - edit candidate',
  navigateBack: '[CandidateListItem header] - navigate back to candidate list',
  openDocumentModal: '[CandidateListItem detail] - open document upload modal',
  saveDocument: '[Document] - save/upload document',
  updateDocumentList: '[CandidateListItem detail] - update/refresh document list',
  updateDetail: '[CandidateListItem detail] - update/refresh candidate details',
  candidateUpdated: '[Candidate Create Update Modal] - create/update candidate',
};
